import React, { FC } from "react";
import styled from "styled-components";

interface FormErrorProps {
  error: string | string[];
}

const FormError: FC<FormErrorProps> = ({ error }) =>
  error && <ErrorParagraph>{error}</ErrorParagraph>;

export default React.memo(FormError);

const ErrorParagraph = styled.p`
  color: ${(props) => props.theme.red};
`;
